import React, { useEffect } from 'react';
import { is } from 'ramda';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import QuizQuestionPresenter from 'presenters/QuizQuestionPresenter';
import QuizPresenter from 'presenters/QuizPresenter';
import InputWithSlider from 'sharedComponents/InputWithSlider';

import useStyles from './useStyles';

const InputQuestion = props => {
  const { question, onChange, values, setValidity, setManuallyChangedField } = props;
  const classes = useStyles();

  const [firstField, secondField] = QuizQuestionPresenter.quizFields(question);
  const hasSecondField = QuizPresenter.hasSecondPerson(values) && !isBlank(secondField);
  const firstFieldValue = QuizPresenter[firstField](values);
  const secondFieldValue = secondField ? QuizPresenter[secondField](values) : null;

  useEffect(() => {
    const isFirstFieldValueValid = is(Number, firstFieldValue);
    const isSecondFieldValueValid = hasSecondField ? is(Number, secondFieldValue) : true;
    const isValid = isFirstFieldValueValid && isSecondFieldValueValid;

    setValidity(isValid);
  }, [firstFieldValue, secondFieldValue]);

  const options = QuizQuestionPresenter.options(question);
  const { min, max, marksDivider, strictLimit } = options;

  const handleValueChange = field => value => {
    setManuallyChangedField({ field });
    onChange({ field, value });
  };
  const total = firstFieldValue + secondFieldValue;
  const readableTotal = QuizPresenter.formattedMoney(total);

  return (
    <Box mb={4}>
      <div className={classes.header}>
        <Typography variant="h1">{QuizQuestionPresenter.label(question)}</Typography>
        {hasSecondField && (
          <Typography variant="h1" className={classes.total}>
            {readableTotal}
          </Typography>
        )}
      </div>
      <Box mt={2} />
      <Box>
        {hasSecondField && (
          <Typography variant="body1">
            {`${QuizQuestionPresenter.description(question)} ${QuizQuestionPresenter.inputLabel(question)}`}
          </Typography>
        )}
        <InputWithSlider
          className={classes.input}
          value={firstFieldValue}
          min={min}
          max={max}
          marksDivider={marksDivider}
          onChange={handleValueChange(firstField)}
          strictLimit={strictLimit}
        />
      </Box>
      {hasSecondField && (
        <Box>
          <Typography variant="body1">
            {`${QuizQuestionPresenter.additionalFieldDescription(question)} ${QuizQuestionPresenter.inputLabel(
              question,
            )}`}
          </Typography>
          <InputWithSlider
            className={classes.input}
            value={secondFieldValue}
            min={min}
            max={max}
            marksDivider={marksDivider}
            onChange={handleValueChange(secondField)}
            strictLimit={strictLimit}
          />
        </Box>
      )}
    </Box>
  );
};

InputQuestion.propTypes = {
  question: QuizQuestionPresenter.shape().isRequired,
  onChange: PropTypes.func.isRequired,
  setValidity: PropTypes.func.isRequired,
  values: QuizPresenter.shape().isRequired,
  setManuallyChangedField: PropTypes.func.isRequired,
};

export default InputQuestion;



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/InputQuestion/InputQuestion.js